
<template>
    <nav id="sampler_nav" class="py-4 text-center">
        <button class="btn mx-2 px-4 py-3 btn-info" href="#" @click="makeEvent($event, 'QR')"> qr</button>
        <button class="btn mx-2 px-4 py-3 btn-info" href="#" @click="makeEvent($event, 'systemFailedFalse')"> system </button>
        <button class="btn mx-2 px-4 py-3 btn-info" href="#" @click="makeEvent($event, 'sessionStart')"> session </button>
        <button class="btn mx-2 px-4 py-3 btn-info" href="#" @click="makeEvent($event, 'deviceIsNotReady')"> process </button>
        <button class="btn mx-2 px-4 py-3 btn-info" href="#" @click="makeEvent($event, 'item')"> item </button>
        <button class="btn mx-2 px-4 py-3 btn-info" href="#" @click="makeEvent($event, 'returnItem')"> returnItem </button>
        <button class="btn mx-2 px-4 py-3 btn-info" href="#" @click="makeEvent($event, 'cancelItem')"> cancelItem </button>
        <button class="btn mx-2 px-4 py-3 btn-info" href="#" @click="makeEvent($event, 'deviceIsReady')"> ready </button>
    </nav>
</template>

<script>
export default {
  components: {
  },
  props: [
      "active"
  ],
  data () {
    return {
    }
  },
  mounted () {
  },
  created () {
  },
  computed: {
  },
  methods: {
      makeEvent(event, type) {
          event.preventDefault();
          this.$emit('eventLaunched', type);
      }
  },
  watch: {
  }
}
</script>

<style scoped lang="scss">
</style>